<template>
  <section id="welcome" style="padding-top: 100px;margin-bottom:50px; text-align:center">
    <loader></loader>

    <div style="display:table-cell; vertical-align: middle; text-align: -webkit-center">
      <div style="margin-bottom:30px">

          <h1 style="color:white; padding:20px">¡Te esperamos pronto!</h1>
        <logo></logo>
        <router-link to="/Login/inicio" tag="button" class="btn boton-primario">Ingresar</router-link>
              <img src="public/images/site/background-welcome-stain.svg" alt="Arkidia" />

      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "../shared/Loader";
import Logo from "../animations/Logo.vue";

export default {
  name: "categoria",
  data() {
    return {};
  },

  methods: {},
  watch: {},
  computed: {},
  components: {
    Loader: Loader,
    Logo: Logo
  },

  mounted: function() {
    const loader = document.querySelector(".loader");
    loader.className += " hidden";
  }
};
</script>

<style scoped>
.ingreso{
  margin:30px;
  border-radius: 15px !important; 
  border: 0px !important;
  width: 250px;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  cursor: pointer;
}
.ingreso:hover{
  box-shadow: -1px 11px 16px 1px rgba(0,0,0,0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

.logo-inicio{
  display:block;
  padding-bottom:60px;
  max-width:600px;
  margin:auto;
}

@media screen and (max-width: 600px) {
  .logo-inicio {
    width: 80%;
    margin:20px;

  }
}
#welcome {
  background: url("/public/images/site/background-welcome.svg") no-repeat 50%
    50%;
  background-color: #0cb9c9;
  display: table;
  height: 100%;
  width: 100%;
  background-position-y: bottom;
  background-size: cover;
}

</style>


// WEBPACK FOOTER //
// src/components/sections/Thanks.vue